import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';

const inp = { padding: '8px 11px', borderRadius: 7, border: '1px solid var(--border-strong)', background: 'var(--bg-app)', color: 'var(--text-primary)', fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box', fontFamily: 'inherit' };

export default function PlayerPicker({ players, selectedIds, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  // Alphabetical, not squad-number order (2026-07-23) — matches every other player dropdown
  // in the app now. A new array, not a mutation of the `players` prop.
  const sortedPlayers = [...players].sort((a, b) => (a.name || '').localeCompare(b.name || ''));

  useEffect(() => {
    const onDocClick = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const toggle = (id) => onChange(selectedIds.includes(id) ? selectedIds.filter(x => x !== id) : [...selectedIds, id]);

  const label = selectedIds.length === 0 ? 'Select players…'
    : selectedIds.length === 1 ? (players.find(p => p.id === selectedIds[0])?.name || '1 player')
    : `${selectedIds.length} players`;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" onClick={() => setOpen(o => !o)}
        style={{ ...inp, display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', textAlign: 'left' }}>
        <span style={{ color: selectedIds.length ? 'var(--text-primary)' : 'var(--text-dimmed)' }}>{label}</span>
        <ChevronDown size={14} color="var(--text-muted)" />
      </button>
      {open && (
        <div style={{ position: 'absolute', top: '110%', left: 0, right: 0, background: 'var(--bg-card)', border: '1px solid var(--border-strong)', borderRadius: 8, zIndex: 50, maxHeight: 300, display: 'flex', flexDirection: 'column', boxShadow: '0 8px 24px rgba(0,0,0,0.3)' }}>
          <div style={{ display: 'flex', gap: 14, padding: '8px 12px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
            <button type="button" onClick={() => onChange(sortedPlayers.map(p => p.id))}
              style={{ background: 'none', border: 'none', color: '#3b82f6', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
              Select all
            </button>
            <button type="button" onClick={() => onChange([])}
              style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
              Clear
            </button>
          </div>
          <div style={{ overflowY: 'auto' }}>
            {sortedPlayers.map(p => (
              <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', fontSize: 13, color: 'var(--text-primary)', cursor: 'pointer' }}>
                <input type="checkbox" checked={selectedIds.includes(p.id)} onChange={() => toggle(p.id)} />
                {p.name}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
